import CustomAxios from ".";

export const uploadBanner = async (file, fileName) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    return await CustomAxios.post(
      `/upload/banner?fileName=${encodeURIComponent(fileName)}`,
      formData,
      {
        headers: {"Content-Type": "multipart/form-data"},
      }
    );
  } catch (error) {
    throw error;
  }
};

export const uploadIntroVideo = async (file, fileName) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await CustomAxios.post(
      `/upload/plan/video?fileName=${encodeURIComponent(fileName)}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};
